import { api } from '../api';
import type { ContainerFlagCodes, FlagCode } from '@/types/container-flag';

/**
 * The tenant's container colour code (T-1005).
 *
 * Writes replace the whole code rather than one colour: red only means something
 * in relation to what green and blue mean, and a per-colour save would let two
 * admins build a code neither of them wrote.
 */
export const containerFlagApi = {
  get: () => api.get<ContainerFlagCodes>('/container-flags'),

  update: (codes: FlagCode[]) => api.put<ContainerFlagCodes>('/container-flags', { codes }),
};
